<div class="flex flex-col gap-8">
  <a
    [routerLink]="backLink()"
    class="inline-flex w-fit items-center gap-1.5 rounded-md text-sm tracking-tight text-zinc-400 transition-colors duration-150 hover:text-zinc-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50">
    <vx-icon name="caret-left" size="sm" />
    {{ backLabel() }}
  </a>

  <div [class]="classes().body">
    <div [class]="classes().intro">
      <div [class]="classes().header">
        <span
          class="flex size-9 shrink-0 items-center justify-center rounded-lg bg-zinc-800 text-zinc-200">
          <vx-icon [name]="icon()" size="lg" />
        </span>
        <div class="flex min-w-0 flex-col gap-1.5">
          <h1 class="text-2xl font-medium tracking-tight text-zinc-50">
            {{ title() }}
          </h1>
          @if (subtitle(); as text) {
            <p class="text-sm tracking-tight text-zinc-400">{{ text }}</p>
          }
        </div>
      </div>
      <!-- empty:hidden so a page without help links keeps no stray gap -->
      <div [class]="classes().aside">
        <ng-content select="[createPageAside]"></ng-content>
      </div>
    </div>

    <div [class]="classes().content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
